import { ScopeBySectorByMode } from '../scopes-types';
import { SCOPES_FESTIVAL } from './scopes-festival';
import { SCOPES_VENUE_DATES } from './scopes-venue-dates';
import { SCOPES_VENUE_STRUCTURE } from './scopes-venue-structure';

export const SCOPES: ScopeBySectorByMode = {
  festival: SCOPES_FESTIVAL,
  'venue-structure': SCOPES_VENUE_STRUCTURE,
  'venue-dates': SCOPES_VENUE_DATES,
};
